import React, { useState,useEffect } from "react";
import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import { Tooltip } from 'react-tooltip'
import { useNavigate } from "react-router";
import { Formik } from 'formik';
import { ToastContainer, toast } from "react-toastify";
import { addUser } from "../utils/schema";
import ErrorMessage from "../components/ErrorMessage";
import { NoAuthApiRequest,ApiRequest } from "./services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../utils/endpoints";
import  Loader from './shared/loader'

import Swal from "sweetalert2";

const Users = () => {
        const [isCollapsed, setIsCollapsed] = useState(false);
        const [loader,setloader]=useState(false);
    const navigate = useNavigate();
    const [search,setsearch]=useState('');
     const [currentPage, setCurrentPage] = useState(1);
         const [pageSize, setPageSize] = useState(50); // Default page size
         const [totalPages, setTotalPages] = useState(0);
    
         const [startCount, setstartCount] = useState("");
         const [endCount, setendCount] = useState("");
         const [totalCount, settotalCount] = useState("");
         const [lstUser,setlstUser]=useState([]);

    const [formData, setFormData] = useState({
        Email: '',
        Name: '',
        RoleId:0,
        Status:"1",
        Id:0,
        UserId:-1,
    });

    useEffect(() => {
    
            const fetchData = async () => {
               await fetchUserList();
            };
            fetchData();
    
        },[]);
    

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };


     const fetchUserList = async()=>{
            await fetchUsers(1,pageSize);
        }
    
             
  const handleKeyPress = async (event) => {
    // Check if the pressed key is Enter (keyCode 13)
    if (event.key === 'Enter') {
        await fetchUserList(1,pageSize);
      // You can trigger any logic here when Enter is pressed
    }
  };

  const handleChanges = (event) => {
    setsearch(event.target.value);
  };

        const handlePageChange = (page) => {
            setCurrentPage(page);
            fetchUsers(page, pageSize);
        };
    
        const fetchUsers = async (page, limit) => {
             
            try {
               // setLoader(true);
                
               setloader(true);
                const data = await ApiRequest(ApiEndpoints.User.FetchUserList(page, limit,search), ApiEndpointMethod.Get, null, navigate);
                
                
                await setlstUser(data.Item1);
                const totalPages = Math.ceil(data.Item2 / limit);
                setTotalPages(totalPages);
    
                const startcount = Math.ceil(
                    Math.ceil(Math.ceil(page * limit) - limit) + 1
                );
                let endcount = Math.ceil(page * limit);
                if (endcount > data.Item2) {
                    endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
                }
                setstartCount(startcount);
                setendCount(endcount);
                settotalCount(data.Item2);
    
                return { data };
                // Handle the response data here (e.g., show success message or update UI)
            } catch (error) {
                console.error("Error during API call:", error);
                // await setfileList([]);
                // Handle errors (e.g., show an error message to the user)
            }
            finally {
             ///   setLoader(false);
             
             setloader(false);
            }
        };
    
        const getPageNumbers = () => {
            // Dynamically generate page numbers
            const pageNumbers = [];
            let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
            let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages
          
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers;
          };

          const validateEmail = (email) => {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if( !emailReg.test( email ) ) {
                return false;
            } else {
                return true;
            }
        }

 const CreateUsers = async (validateForm, setTouched, values) => {
            try{
                const errors = await validateForm();
                //if (Object.keys(errors).length === 0) {
                    
                if(formData.Name == "" || formData.Name == undefined || formData.Name == undefined){
                    toast.error("Please enter the name", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return true;
                }
                    
               else  if(formData.Email == "" || formData.Name == undefined || formData.Name == undefined){
                toast.error("Please enter the email", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                    return true;
                }
                else if(formData.Email !== null && formData.Email !==undefined && formData.Email !==''){
                
                                            if(!validateEmail(formData.Email)){
                                            toast.error("Please enter the valid email", {
                                                position: "top-right",
                                                autoClose: 3000,
                                                hideProgressBar: false,
                                                closeOnClick: true,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            });
                                            return true;
                                 }
                }
              
                 if(formData.RoleId == 0){
                    toast.error("Please select the role", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    return true;
                }      
                

               setloader(true);
                    const usrDetails = JSON.parse(localStorage.getItem("user"));
                    formData.UserId=usrDetails.Id;
                    const data = await ApiRequest(ApiEndpoints.User.CreateUser, ApiEndpointMethod.Post, formData, navigate);
                    if(data.success==true){
                     
                        await fetchUsers(1,pageSize);
                        document.getElementById('btnclose').click();
                        toast.success(data.message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        await clearData();
                    }
                    else{
                        toast.error(data.message, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }
               
            } catch (error) {
                // Handle network errors or any other errors
                console.error("There was an error sending the form data", error);
                toast.success(error, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            finally {
                
               setloader(false);
            }
    };

    const clearData = async ()=>{
       
        await handleChangeTigger("Email", '');
        await handleChangeTigger("Name", '');
        await handleChangeTigger("Id", 0);
        await handleChangeTigger("RoleId", 0);
        await handleChangeTigger("Status", 1);
        await handleChangeTigger("UserId", -1);
    }

    const EditUser = async(UserId) =>{
       // alert(UserId);

         setloader(true);
                        document.getElementById('mdlAddUsers').click();
                    
                                const data = await ApiRequest(ApiEndpoints.User.EditUser(UserId), ApiEndpointMethod.Get, navigate);
                                      if(data != null && data.success==true) {
                                      
                                        await handleChangeTigger("Email", data.message.Email);
                                        await handleChangeTigger("Name", data.message.Name);
                                        await handleChangeTigger("Id", data.message.Id);
                                        await handleChangeTigger("RoleId", data.message.Role?.Id);
                                        if(data.message.IsActive==true){
                                        await handleChangeTigger("Status", 1);
                                        }
                                        else{
                                            await handleChangeTigger("Status", 0); 
                                        }
                                        //alert(data);
                                      }
                                      setloader(false);
    }

    const handleChangeTigger = async (name, value) => {
  
        setFormData((prevState) => ({
         ...prevState,
         [name]: value,
       }));
 };

   const DeleteUser = async(UserId) => {
                     const result = await Swal.fire({
                         title: '',
                         text:  "Are you sure want to delete the user?",
                         icon: "warning",
                         showCancelButton: true,
                         confirmButtonText: "Yes",
                         cancelButtonText: "No",
                         reverseButtons: true,
                       });
                       if (result.isConfirmed) {
                         setloader(true);
                         const data = await ApiRequest(ApiEndpoints.User.DeleteUser(UserId), ApiEndpointMethod.Get, null,navigate);
                         if(data == ""){
                            
                                          toast.success("User deleted successful", {
                                              position: "top-right",
                                              autoClose: 3000,
                                              hideProgressBar: false,
                                              closeOnClick: true,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                          });
                                        await fetchUsers(currentPage, pageSize);
                         }
                         
                         setloader(false);
                       }
                 }


    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Users</h5>
                            <div className="d-flex align-items-center">
                                <input className="form-control me-2" placeholder="search..." 
                                 onChange={handleChanges}  onKeyDown={handleKeyPress} value={search} type="search" style={{ width: '220px' }} />
                                {/* <button className="btn btn-sm btn-info me-2" data-bs-toggle="modal"
                                    data-bs-target="#addUser">
                                    <i className="fas fa-plus me-1"></i>Add User
                                </button> */}
                                <button className="btn btn-sm btn-outline-info" id="mdlAddUsers" data-bs-toggle="modal"
                                    data-bs-target="#addUser">
                                    <i className="fas fa-user-plus me-1"></i>Add User
                                </button>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="table table-striped table-bordered bg-white mb-0">
                                <thead>
                                    <tr>
                                        <th width="20%">Name</th>
                                        <th width="20%">Email</th>
                                        <th width="20%">Role</th>
                                        <th width="20%">Status</th>
                                        <th width="20%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {lstUser?.map((user) => (
                                    <tr>
                                        <td>{user.Users.Name}</td>
                                        <td>{user.Users.Email}</td>
                                        <td>{user.Roles.Name}</td>
                                        <td>{user.Users.IsActive && <span>Active</span>} 
                                        {!user.Users.IsActive && <span>Inactive</span>}
                                        </td>
                                        <td className="text-center">
                                            {user.Users.Email != "admin@expsoltechs.com" && (
                                                <>
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit" onClick={()=>EditUser(user.Users.Id)}>
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete" onClick={()=>DeleteUser(user.Users.Id)}>
                                                <i className="fas fa-trash-alt"></i></a>
                                            </>
                                             )}
                                        </td>
                                    </tr>
                                ))}
                                    {/* <tr>
                                        <td>Joe West</td>
                                        <td>joewest@expsotlechs.com</td>
                                        <td>Admin</td>
                                        <td className="text-primary fw-semibold">Active</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Oliver Queen</td>
                                        <td>oliverqueen@expsotlechs.com</td>
                                        <td>Lead</td>
                                        <td className="text-muted fw-semibold">InActive</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Felicity Smoak</td>
                                        <td>felicitysmoak@expsotlechs.com</td>
                                        <td>Manager</td>
                                        <td className="text-primary fw-semibold">Active</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                        
                        <div className="pagination-wrapper shadow-sm">
                               <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                               <ul className="pagination">
                                   <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                           <i className="fa-solid fa-chevron-left"></i>
                                       </a>
                                   </li>

                                   {getPageNumbers().map((page) => (
                                       <li key={page} >
                                           <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                               {page}
                                           </a>
                                       </li>
                                   ))}

                                   <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                           <i className="fa-solid fa-chevron-right"></i>
                                       </a>
                                   </li>
                               </ul>
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="addUser" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add User</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={()=>{clearData();}}></button>
                        </div>
                        <Formik
                                    enableReinitialize={true}
                                    initialValues={formData}
                                    validationSchema={addUser()}
                                    onSubmit={(values, actions) => {
                                        CreateUsers(values);
                                    }}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange1,
                                        handleBlur,
                                        handleSubmit,
                                        setFieldValue,
                                        setTouched,
                                        validateForm,
                                    }) => (
                                        <form>
                        <div className="modal-body">
                      
                            <div className="form-group">
                                <label>Name<span className="text-danger">*</span></label>
                                <input className="form-control" type="text" 
                                 value={formData?.Name}
                                 name="Name"
                                 onChange={handleChange}
                                 onBlur={handleBlur}
                                 onInput = {(e) =>{
                                    e.target.value = e.target.value.toString().slice(0,60)
                                }}
                                 />
                            </div>
                            <div className="form-group">
                                <label>Email<span className="text-danger">*</span></label>
                                <input className="form-control" type="email" 
                                value={formData?.Email}
                                name="Email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onInput = {(e) =>{
                                    e.target.value = e.target.value.toString().slice(0,80)
                                }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Role<span className="text-danger">*</span></label>
                                <select className="form-control" value={formData?.RoleId} // The selected option will be based on the value of rowData?.Email
  name="RoleId" // The name of the select field
  onChange={handleChange} // The function to handle changes when a new option is selected
  onBlur={handleBlur}>
                                    <option value="0">--Select--</option>
                                    <option value="1">Admin</option>
                                    <option value="2">Lead</option>
                                    <option value="3">Employee</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Status</label>
                                <select className="form-control" value={formData?.Status} // The selected option will be based on the value of rowData?.Email
  name="Status" // The name of the select field
  onChange={handleChange} // The function to handle changes when a new option is selected
  onBlur={handleBlur}>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </select>
                            </div>
                          
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="btnclose" className="btn btn-sm btn-outline-info me-2"
                             data-bs-dismiss="modal" onClick={()=>{clearData();}}>
                                <i className="fas fa-times me-2"></i>Cancel
                            </button>
                            <button type="button" className="btn btn-sm btn-info" 
                             onClick={() => CreateUsers(validateForm, setTouched, values)}>
                                <i className="fas fa-check me-2"></i>Save
                            </button>
                        </div>
                        </form>
                             )}
                             </Formik>
                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            {loader && (
                <Loader/>
            )}
        </>
    )
}

export default Users;